export interface GridState {
  FieldName: string
  Width: number
  Pos: number
}

export type GridViewParams = {
  formName: string
  objectName?: string
}

export type GridSaveParams = {
  formName: string
  objectName: string
  gridStates: GridState[]
}

export interface GridServerResponse {
  [key: string]: GridState
}

export enum GridsServiceErrorCode {
  GENERAL,
}
